import React, { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import LOGIN_EXPIRY_TIME_SECONDS from './components/common/constants';
import { clearUser, setUser } from './redux/actions/user-actions';
import { request } from './components/common/utils';

import Routes from './route/routes';

const TRACKING_ID = 'G-PBR7VR1Z97'; // your Measurement ID

function App({
  user,
  timeLoggedIn,
  clearUserDetails,
  setUserDetails,
}) {
  const sessionValidatedForUserId = useRef(null);

  // TODO: Can we auto logout the user after the time has expired?
  // This will check if the user is logged in
  // and if the time has expired when the page is loaded
  useEffect(() => {
    if (!user || Object.keys(user).length === 0) {
      localStorage.removeItem('token');
      clearUserDetails();
    } else if (timeLoggedIn) {
      const elapsedTime = Date.now() - timeLoggedIn;
      if (elapsedTime >= LOGIN_EXPIRY_TIME_SECONDS * 1000) {
        localStorage.removeItem('token');
        clearUserDetails();
      }
    }
  }, []);

  useEffect(() => {
    if (!user?.id) {
      sessionValidatedForUserId.current = null;
      return undefined;
    }
    if (sessionValidatedForUserId.current === user.id) {
      return undefined;
    }
    let cancelled = false;
    request('/me', 'GET', { skipSessionRecovery: true })
      .then((res) => {
        if (!cancelled) {
          sessionValidatedForUserId.current = user.id;
          setUserDetails(res.data);
        }
      })
      .catch(() => {
        if (!cancelled) {
          sessionValidatedForUserId.current = null;
        }
      });
    return () => {
      cancelled = true;
    };
  }, [user?.id, setUserDetails]);

  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Routes user={user} />
    </LocalizationProvider>
  );
}

App.propTypes = {
  user: PropTypes.oneOfType([PropTypes.object]).isRequired,
  timeLoggedIn: PropTypes.number,
  clearUserDetails: PropTypes.func.isRequired,
  setUserDetails: PropTypes.func.isRequired,
};

App.defaultProps = {
  timeLoggedIn: null,
};

const mapStateToProps = (state) => ({
  user: state.user.userDetails,
  timeLoggedIn: state.user.timeLoggedIn,
});

const enhance = compose(
  connect(
    mapStateToProps,
    {
      clearUserDetails: clearUser,
      setUserDetails: setUser,
    },
  ),
);
export default enhance(App);
